<template>
  <section class="section section--gray">
    <div class="container kpi__inner">
      <div class="kpi__content">
        <span class="section__label">Показатели эффективности</span>
        <h2 class="section__title">KPI-карта, которая сама идёт в&nbsp;премию</h2>
        <p class="section__subtitle kpi__subtitle">
          Соберите карту показателей сотрудника: каждому индикатору — свой вес и фактический
          процент выполнения. Система считает взвешенный итог карты, и он автоматически
          становится множителем в формуле премии.
        </p>
        <ul class="kpi__list">
          <li>Каждый KPI — из справочника показателей, свой или каскадом от KPI руководителя</li>
          <li>Итог карты = Σ(вес × % выполнения) ÷ Σ весов</li>
          <li>Веса можно не сводить к 100% — система нормирует сама</li>
          <li>Готовый коэффициент подставляется в премию как фактор</li>
          <li>У каждого сотрудника — свой раздел «Показатели эффективности»</li>
        </ul>
      </div>
      <div class="kpi__visual">
        <div class="kpi__card">
          <div class="kpi__card-label">Карта показателей: менеджер по продажам</div>
          <table class="kpi__table">
            <thead>
              <tr><th>Показатель</th><th>Вес</th><th>Выполнение</th></tr>
            </thead>
            <tbody>
              <tr><td>План продаж</td><td>50%</td><td>120%</td></tr>
              <tr><td>Возвраты клиентов</td><td>30%</td><td>90%</td></tr>
              <tr><td>Скорость ответа</td><td>20%</td><td>80%</td></tr>
            </tbody>
          </table>
          <div class="kpi__result">
            Выполнение карты <strong>103%</strong>
            <span class="kpi__arrow">→</span>
            коэффициент премии <strong>1,03</strong>
          </div>
          <div class="kpi__card-footer">
            <span class="kpi__check">✓</span> Итог карты подставляется в формулу премии множителем
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'KpiSection',
}
</script>

<style scoped>
.kpi__inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}
.kpi__subtitle { margin-bottom: 24px; }
.kpi__list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.kpi__list li {
  color: var(--gray);
  font-size: 0.9375rem;
  padding-left: 24px;
  position: relative;
  line-height: 1.6;
}
.kpi__list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--secondary);
  font-weight: 700;
}
.kpi__card {
  background: white;
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 32px;
  box-shadow: var(--shadow);
}
.kpi__card-label {
  font-size: 0.8125rem;
  color: var(--gray);
  font-weight: 500;
  margin-bottom: 16px;
}
.kpi__table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
.kpi__table th {
  text-align: left;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--gray);
  font-weight: 600;
  padding: 0 0 10px;
  border-bottom: 1px solid var(--border);
}
.kpi__table th:not(:first-child),
.kpi__table td:not(:first-child) { text-align: right; }
.kpi__table td {
  font-size: 0.9375rem;
  color: var(--dark);
  padding: 10px 0;
  border-bottom: 1px solid var(--border);
}
.kpi__result {
  font-size: 1rem;
  color: var(--dark);
  font-weight: 600;
  margin-bottom: 20px;
  line-height: 1.6;
}
.kpi__result strong { color: var(--primary); }
.kpi__arrow { color: var(--gray); margin: 0 6px; }
.kpi__card-footer {
  border-top: 1px solid var(--border);
  padding-top: 16px;
  font-size: 0.875rem;
  color: var(--gray);
  display: flex;
  align-items: center;
  gap: 8px;
}
.kpi__check { color: var(--secondary); font-weight: 700; }

@media (max-width: 900px) {
  .kpi__inner { grid-template-columns: 1fr; gap: 40px; }
}
</style>
